<template lang="pug">
  .checkout-page.page-left-right.grid(:class="[ grid, { 'page-leave-active page-leave-to': leave } ]")
    .col.left-area
      affix.sticky-stuff(
        ref="left"
        relative-element-selector=".scroll-area"
        :enabled="sticky"
        :scroll-affix="true"
        :offset="{ top: 0, bottom: 0 }"
      )
        slot(name="header")
        main
          section
            CheckoutStepper(:areas="areas")
    .scroll-area(ref="scroll")
    .col.right-area(v-if="right.length")
      affix.sticky-stuff(
        ref="right"
        relative-element-selector=".scroll-area"
        :enabled="sticky"
        :scroll-affix="true"
        :offset="{ top: 0, bottom: 0 }"
      )
        section(
          v-for="(section, index) in right"
          :key="section.id"
          :class="section.key"
        )
          Post(v-if="section.key === 'post'" :section="section")
          ImageSection(v-if="section.key === 'image'" :section="section")
          PhotoAlbum(v-if="section.key === 'photoalbum'" :section="section")
    slot(name="footer")
</template>
<script>
// import { mapGetters } from 'vuex';

import ContentPage from '@/views/ContentPage';

import ImageSection from '@/components/ImageSection';
import PhotoAlbum from '@/components/PhotoAlbum';
import Post from '@/components/Post';

import Authenticate from '@/extensions/restricted-area/components/Authenticate';
import CheckoutStepper from '@/extensions/shop/components/CheckoutStepper';

export default {
    name: 'Checkout',
    extends: ContentPage,
    components: {
        Authenticate,
        CheckoutStepper,
        ImageSection,
        Post,
        PhotoAlbum
    },
    computed: {
        // left() {
        //   let sections = [];
        //   if (this.areas.left && this.areas.left.length) {
        //     const supported = [];
        //     sections = this.areas.left.filter(el => supported.includes(el.key));
        //   }
        //   return sections;
        // },
        right() {
            let sections = [];
            if (this.areas.right && this.areas.right.length) {
                const supported = ['post', 'image', 'photoalbum'];
                sections = this.areas.right.filter(el => supported.includes(el.key));
            }
            return sections;
        },
        grid() {
            let grid = 'col-1';
            if (this.right.length) {
                grid = 'col-2';
            }
            return grid;
        }
    }
};
</script>
<style lang="sass" nolang="scss" scoped>
// @import "~@/assets/sass/variables"

section.slider,
section.banners
  padding: 0
section.heading
  padding-bottom: 0
</style>
